// extracted by mini-css-extract-plugin
export default {"productGrid":"g1-z","centerLink":"h1-z","productSection":"i1-z","item":"j1-z","ctaButton":"k1-z"};